import { apiService } from '../general/APIService';

const DIFFUSERS_ENDPOINT = 'diffusers';

export async function getDiffusers() {
    const response = await apiService.get(DIFFUSERS_ENDPOINT);

    return response.data.data;
}
